import React from 'react';
import { ForgeCommentaryExperience } from '../../utils/commentary/commentaryDataTypes';
import { ArtistCommentarySubForm } from './ArtistCommentarySubForm';

interface Props {
    onAlbumExperienceChanged: (exp: ForgeCommentaryExperience) => void;
    onAlbumExperienceDeleted: (exp: ForgeCommentaryExperience) => void;
    onTrackExperienceChanged: (exp: ForgeCommentaryExperience) => void;
    onTrackExperienceDeleted: (exp: ForgeCommentaryExperience) => void;
    albumImageFile?: File;
    albumCommentary?: ForgeCommentaryExperience;
    trackCommentaries: ForgeCommentaryExperience[];
}

export class ArtistCommentaryFormManager extends React.Component<Props> {
    constructor(props: any) {
        super(props);
    }

    render(): JSX.Element {
        return (
            <React.Fragment>
                {this.props.albumCommentary && !this.props.albumCommentary.isForDeletion ? (
                    <div className="awsui-row" hidden={!this.props.albumCommentary}>
                        <div className="col-xxxs-12">
                            <ArtistCommentarySubForm
                                albumImageFile={this.props.albumImageFile}
                                experience={this.props.albumCommentary}
                                headerText={'Album Commentary'}
                                onExperienceChanged={this.props.onAlbumExperienceChanged}
                                onExperienceDeleted={this.props.onAlbumExperienceDeleted}
                            ></ArtistCommentarySubForm>
                        </div>
                    </div>
                ) : null}
                {this.props.trackCommentaries
                    .filter((commentary) => !commentary.isForDeletion)
                    .map((commentary) => {
                        return (
                            <div className="awsui-row" key={commentary.key}>
                                <div className="col-xxxs-12">
                                    <ArtistCommentarySubForm
                                        albumImageFile={this.props.albumImageFile}
                                        experience={commentary}
                                        headerText={'Track Commentary'}
                                        onExperienceChanged={this.props.onTrackExperienceChanged}
                                        onExperienceDeleted={this.props.onTrackExperienceDeleted}
                                    ></ArtistCommentarySubForm>
                                </div>
                            </div>
                        );
                    })}
            </React.Fragment>
        );
    }
}
